<template>
  <v-app>
    <v-main>
      <ARQEntry/>
      <SnackMessageBar />
    </v-main>
  </v-app>
</template>

<script>
import ARQEntry from './components/ARQEntry';
import SnackMessageBar from '@/components/SnackMessageBar'

export default {
  name: 'App',

  components: {
    ARQEntry,
    SnackMessageBar
  },

  data: () => ({
    //
  }),
};
</script>

<style>
    /* body, html                        { overflow: hidden; } */
  
    ::-webkit-scrollbar               { width: 10px; }
    ::-webkit-scrollbar-track         { background: #dde5ed; }
    ::-webkit-scrollbar-thumb         { background: #1E5288; }
    ::-webkit-scrollbar-thumb:hover   { background: #555; }
</style>
